import { render } from "./Employee.vue?vue&type=template&id=1552e5ca"
import script from "./Employee.vue?vue&type=script&lang=ts"
export * from "./Employee.vue?vue&type=script&lang=ts"
script.render = render

export default script